import cn from 'classnames';
import type { ComponentPropsWithRef } from 'react';

import * as styles from './styles.module.css';

interface Props extends ComponentPropsWithRef<'input'> {
  errorMessage?: string;
  'data-testid'?: string;
}

export const InputError = ({ errorMessage, ...props }: Props) => {
  return errorMessage ? (
    <div
      role="alert"
      className={cn(
        styles['input-error'],
        'mt-2 rounded-2xl bg-feedback-error-surface p-3 text-sm drop-shadow-sm first-letter:capitalize'
      )}
      {...props}
    >
      {errorMessage}
    </div>
  ) : null;
};
